import { render } from "./PayView.vue?vue&type=template&id=926d21d4"
import script from "./PayView.vue?vue&type=script&lang=js"
export * from "./PayView.vue?vue&type=script&lang=js"

import "./PayView.vue?vue&type=style&index=0&id=926d21d4&lang=css"

import exportComponent from "/opt/apps/golden_telecom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__